import { useClickAway } from "ahooks";
import React, { useEffect, useState } from "react";
import styles from "./index.module.less";

enum TriggerType {
  click = "click",
  hover = "hover",
}
/**
 * groupID 当一个页面存在多个FilterGroup时，需要设置不同groupID 用来区分
 *
 */
export default function FilterGroup({ children, groupID = 0 }) {
  const [active, setActive] = useState<number>(null);
  const [groupActive, setGroupActive] = useState<boolean>(false);
  const [filterList, setFilterList] = useState([]);
  useEffect(() => {
    setFilterList(
      Array.from(
        document.querySelectorAll(`[data-filter-id=filter-${groupID}]`)
      )
    );
  }, [children, groupID]);

  useClickAway(
    (e) => {
      // 点击下拉选项以外的地方，则恢复默认交互，收起下拉
      setGroupActive(false);
      setActive(null);
    },
    filterList,
    ["click"]
  );

  const changeActiveFilter = (index, trigger, e) => {
    // 点击方式展开下拉选项，后续hover就能展开

    if (TriggerType.click === trigger) {
      // 重复点击则关闭
      setActive(active === index ? null : index);
    } else {
      setActive(index);
    }
  };
  useEffect(() => {
    setGroupActive(active !== null);
  }, [active]);
  return (
    <>
      {React.Children.map(children, (child, index) => {
        if (!child) {
          return;
        }

        return (
          <div
            className={styles.filterItem}
            onClick={(e) => changeActiveFilter(index, TriggerType.click, e)}
            onMouseEnter={(e) =>
              groupActive && changeActiveFilter(index, TriggerType.hover, e)
            }
            data-filter-id={`filter-${groupID}`}
          >
            {React.cloneElement(child, {
              customprops: {
                visible: active === index && !child.props.disabled,
              },
            })}
          </div>
        );
      })}
    </>
  );
}
